import { ACCOUNT_CREATE_ACTION_TYPE_ENUM } from '@components-member/TradingAccounts/AccountCreate/enums';
import { IAccountCreateAction, IAccountCreateInitialState } from './interfaces';

export const accountCreateState: IAccountCreateInitialState = {
  [ACCOUNT_CREATE_ACTION_TYPE_ENUM.CREATION_SETTING]: {
    canCreateDemoAccountForNonApproved: true,
    canCreateRealAccountForNonApproved: true,
    tradingPlatformBrandingSettings: [],
  },
  [ACCOUNT_CREATE_ACTION_TYPE_ENUM.SELF_TRADING_TYPES]: [],
  [ACCOUNT_CREATE_ACTION_TYPE_ENUM.MASTER_TRADING_TYPES]: [],
  [ACCOUNT_CREATE_ACTION_TYPE_ENUM.INVESTOR_TRADING_TYPES]: [],
  [ACCOUNT_CREATE_ACTION_TYPE_ENUM.PROCESSING]: true,
};

export const accountCreateReducer = (
  state: IAccountCreateInitialState,
  action: IAccountCreateAction,
): IAccountCreateInitialState => {
  switch (action.type) {
    case ACCOUNT_CREATE_ACTION_TYPE_ENUM.CREATION_SETTING:
      return { ...state, [ACCOUNT_CREATE_ACTION_TYPE_ENUM.CREATION_SETTING]: action.payload };
    case ACCOUNT_CREATE_ACTION_TYPE_ENUM.SELF_TRADING_TYPES:
      return { ...state, [ACCOUNT_CREATE_ACTION_TYPE_ENUM.SELF_TRADING_TYPES]: action.payload };
    case ACCOUNT_CREATE_ACTION_TYPE_ENUM.MASTER_TRADING_TYPES:
      return { ...state, [ACCOUNT_CREATE_ACTION_TYPE_ENUM.MASTER_TRADING_TYPES]: action.payload };
    case ACCOUNT_CREATE_ACTION_TYPE_ENUM.INVESTOR_TRADING_TYPES:
      return { ...state, [ACCOUNT_CREATE_ACTION_TYPE_ENUM.INVESTOR_TRADING_TYPES]: action.payload };
    case ACCOUNT_CREATE_ACTION_TYPE_ENUM.PROCESSING:
      return { ...state, [ACCOUNT_CREATE_ACTION_TYPE_ENUM.PROCESSING]: action.payload };
    default:
      return state;
  }
};
